<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';
import CloseWindowIconBtn from '@/components/iconBtns/CloseWindowIconBtn.vue';
import NewAirRoadProductSizeText from '@/components/texts/NewAirRoadProductSizeText.vue';
import NewAirRoadProductWeightText from '@/components/texts/NewAirRoadProductWeightText.vue';

export interface Props {
  product?: ReadonlyDeep<
    | openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products'][0]
    | Partial<
        openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products'][0]
      >
  >;
  close?: () => void;
  draggable?: boolean;
  isQuantity?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  product: () => ({}),
  close: undefined,
  draggable: false,
  isQuantity: true,
});
</script>

<template>
  <li
    :class="$style.newAirRoadUnpackedProductsBasicListItem"
    data-testid="newAirRoadUnpackedProductsBasicListItem"
    :draggable="props.draggable"
  >
    <div :class="$style.header">
      <div v-if="props.isQuantity" :class="$style.quantity">
        {{ getStrCell(props.product.quantity) }}
      </div>
      <div :class="$style.model">
        {{ getStrCell(props.product.model) }}
      </div>
      <div v-if="props.draggable" :class="$style.drag">
        <v-icon icon="mdi-drag"></v-icon>
      </div>
      <div v-if="props.close" :class="$style.close">
        <CloseWindowIconBtn :class="$style.closeBtn" @click="props.close" />
      </div>
    </div>
    <div :class="$style.main">
      <div :class="$style.size">
        <NewAirRoadProductSizeText :product="props.product" />
      </div>
      <div :class="$style.weight">
        <NewAirRoadProductWeightText :product="props.product" />
      </div>
    </div>
  </li>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadUnpackedProductsBasicListItem {
  line-height: 1.4;
  border: 1px solid colors.$color-gray-300;
  border-radius: 4px;
  list-style-type: none;
}
  .header {
    display: flex;
    padding: 6px 16px;
    background-color: colors.$color-gray-100;
    min-height: 36px;
    align-items: start;
    justify-content: center;
  }
    .quantity {
      flex-shrink: 0;
      background-color: colors.$color-white;
      border-radius: 50%;
      min-width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 500;
      padding: 0 5px;
      margin-right: 16px;
    }
    .model {
      width: 100%;
      height: 100%;
      font-weight: 500;
      align-self: center;
      margin-right: 16px;
    }
    .drag {
      flex-shrink: 0;
      font-size: 15px;
    }
    .close {
      flex-shrink: 0;
      margin-right: -16px;
    }
      .closeBtn {
        margin: -8px 0 -6px 0;
      }
  .main {
    display: flex;
    gap: 16px;
    padding: 11px 16px;
    align-items: center;
  }
    .size {
      width: 100%;
    }
    .weight {
      width: 31%;
      flex-shrink: 0;
    }
</style>
